import moment, { Moment } from "moment";
import { PubTournament } from "../api/types";

export const calcPlayTime = (
  startedAt: Moment,
  playTimeSec: number,
  restTimeSec: number,
): number => {
  let playTime = Math.max(moment().unix() - startedAt.unix(), 0);
  let restCount = Math.floor(playTime / (playTimeSec + restTimeSec));
  playTime -= restCount * restTimeSec;

  return playTime;
};

export const calcLevel = (
  playTime: number,
  blindStructure: Array<Array<number>>,
): number => {
  let level = 0;
  for (let levelInfo of blindStructure) {
    if (playTime >= levelInfo[3]) {
      playTime -= levelInfo[3];
      ++level;
    } else {
      break;
    }
  }

  if (level > blindStructure.length - 1) level = blindStructure.length - 1;

  return level;
};

export const calcBlindUpTime = (
  playTime: number,
  blindStructure: Array<Array<number>>,
): number => {
  let result = 0;

  for (let levelInfo of blindStructure) {
    if (playTime >= levelInfo[3]) {
      playTime -= levelInfo[3];
    } else {
      result = levelInfo[3] - playTime;
      break;
    }
  }
  if (result < 0) return 0;
  return result;
};

// 양수면 라운드 경과시간, 음수면 시작시간까지 남은 시간
export const calcElapsedForRound = (
  startedAt: Moment,
  playTimeSec: number,
  restTimeSec: number,
): number => {
  const now = moment().unix();
  const elapsedSec = now - startedAt.unix();

  if (elapsedSec >= 0) {
    return Math.floor(elapsedSec % (playTimeSec + restTimeSec));
  } else {
    return elapsedSec;
  }
};

export const determineRestTime = (
  startedAt: Moment,
  playTimeSec: number,
  restTimeSec: number,
) => {
  const elapsedForRound = calcElapsedForRound(
    startedAt,
    playTimeSec,
    restTimeSec,
  );
  return elapsedForRound >= playTimeSec;
};

// 현재 플레이어 텍스트
export const getPlayersText = (item: PubTournament) => {
  const total =
    item.entryUserCount + item.reBuyInUserCount + item.adOnUserCount;

  return `${item.userCount}/${total}`;
};

// 현재 레벨 텍스트
export const getLevelText = (item: PubTournament) => {
  if (item.timeInfo.currentLevel.type === "BREAK") {
    const ord = item.timeInfo.currentLevel.ord;
    const currentIndex = item.structure.findIndex((item) => item.ord === ord);
    const prevLevel = item.structure[currentIndex - 1]?.level;
    if (!prevLevel) {
      const prevPrevLevel = item.structure[currentIndex - 2]?.level;
      return `BREAK (LV${prevPrevLevel})`;
    }
    return `BREAK (LV${prevLevel})`;
  }
  if (item.timeInfo.currentLevel.type === "READY") return "준비중";

  return `LV ${item.timeInfo.currentLevel.level}`;
};

// 현재 블라인드 텍스트
export const getCurrentBlindTitle = (item: PubTournament) => {
  if (item.timeInfo.currentLevel.type === "READY") return "시작 BLIND";
  return "현재 BLIND";
};

// 블라인드 값 텍스트
export const getBlindValue = (item: PubTournament, type: string) => {
  if (type === "current") {
    const current = item.timeInfo.currentLevel;
    if (current.type === "BREAK") return "BREAK";
    return `${current.smallBlind} / ${current.bigBlind} (${current.ante})`;
  }
  if (type === "next") {
    const next = item.timeInfo.nextLevel;
    if (next.type === "BREAK") return "BREAK";
    return `${next.smallBlind} / ${next.bigBlind} (${next.ante})`;
  }
};

// 엔트리 or 예약자 수
export const getEntryButtonText = (item?: PubTournament): string => {
  if (!item) return "";
  const totalCapacity =
    item.adOnUserCount + item.entryUserCount + item.reBuyInUserCount;

  // 예약이 있고 토너먼트가 시작 되기 전
  if (item.reservation && !item.isEnd && item.timeInfo?.elapsedTimeMs < 0) {
    // 인원 제한 예약
    if (item.reservation?.limitEntry) {
      return `${item.reservationCount}/${item.reservation.limitEntry}명`;
    }
    // 일반 예약
    return `${item.reservationCount}명`;
  }

  // 기본
  return `${item.userCount}/${totalCapacity}명`;
};
